import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { requestPasswordReset } from '../api/authService';
import companyLogo from '../assets/company-logo.svg';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email || !email.includes('@')) {
      setError('Please enter a valid email address');
      return;
    }

    setError('');
    setMessage('');
    setIsSubmitting(true);

    try {
      const response = await requestPasswordReset(email);
      setMessage(response.message || 'If your email exists in our system, you will receive password reset instructions.');
      setEmail('');
    } catch (err) {
      setError(err.message || 'Something went wrong. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="container-auth">
      <div className="box-auth">
        <div className="logo-wrapper">
          <img src={companyLogo} alt="Redwood Midcap" className="logo" />
        </div>
      
      {message ? (
        <div className="form-group-auth">
          <p className="label-auth">{message}</p>
          <p className="signup-text">
            <Link to="/login">Return to Login</Link>
          </p>
        </div>
      ) : (
        <>          
          {error && <p style={{ color: 'red' }}>{error}</p>}
          
          <form onSubmit={handleSubmit}>
            <div className="form-header-auth">
              <h2>Reset Your Password</h2>
              <p>Enter your email address and we'll send you instructions to reset your password.</p>
            </div>
              
            <div className="form-group-auth">  
              <label className="label-auth" for="email">Email</label>
              <input
                className="input-field"
                placeholder="Input your E-Mail"
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={isSubmitting}
              />
            </div>
            <button className="button-auth" type="submit" disabled={isSubmitting}>
              {isSubmitting ? (
                <>
                  Sending<span className="dots" />
                </>
              ) : (
                'Send Reset Link'
              )}
            </button>
          </form>
          
          <p className="signup-text">
            <Link to="/login">Back to Login</Link>
          </p>
        </>
      )}
      </div>
    </div>
  );
}

export default ForgotPassword;